import { defineStore } from 'pinia';

export const useLoginTimeout = defineStore('status', {
  state: () => ({
    value: false
  }),
  actions: {
    statusDialog(status) {
      this.value = status;
    }
  }
});
